import React, { useMemo, useState, useCallback, useRef } from 'react';
// eslint-disable-next-line import/extensions
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './styles.scss';
import cn from 'classnames';
import DateTimeCarouselButton from 'widget/event_components/Ticket/components/Datetime/components/DateTimeCarouselButton';

export const DateCarousel = ({ dateTimeEntries, selectedOccurrence, onClickOccurrence }) => {
  const swiperRef = useRef();
  const [isLeftButtonDisabled, setIsLeftButtonDisabled] = useState(false);
  const [isRightButtonDisabled, setIsRightButtonDisabled] = useState(false);

  const checkSwiperState = (swiper) => {
    if (swiper.isBeginning) {
      setIsLeftButtonDisabled(true);
      setIsRightButtonDisabled(false);
    }
    if (swiper.isEnd) {
      setIsLeftButtonDisabled(false);
      setIsRightButtonDisabled(true);
    }
    if (!swiper.isEnd && !swiper.isBeginning) {
      setIsLeftButtonDisabled(false);
      setIsRightButtonDisabled(false);
    }
  };

  const onBeforeInit = (swiper) => {
    swiperRef.current = swiper;
    checkSwiperState(swiper);
  };

  const handleOnTransitionSlide = useCallback((swiper) => {
    checkSwiperState(swiper);
  }, []);

  const slides = useMemo(
    () =>
      dateTimeEntries.map((date, index) => (
        <SwiperSlide
          key={`${Math.random() * index}`}
          className={cn(styles.swiperSlide, { [styles.selected]: date.id === selectedOccurrence })}
          onClick={() => onClickOccurrence(date.id)}
        >
          <div className={styles.week}>{date.start.format('ddd')}</div>
          <div className={styles.day}>{date.start.format('D MMM')}</div>
        </SwiperSlide>
      )),
    [selectedOccurrence]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.swiperContainer}>
        <Swiper
          spaceBetween={8}
          slidesPerView={5}
          onTransitionStart={handleOnTransitionSlide}
          onBeforeInit={onBeforeInit}
          className={styles.dateTimeCarousel}
        >
          <DateTimeCarouselButton key="left" disabled={isLeftButtonDisabled} direction="left" />
          {slides}
          <DateTimeCarouselButton key="right" disabled={isRightButtonDisabled} direction="right" />
        </Swiper>
      </div>
    </div>
  );
};
